export interface TypedEvidenceValue {
  fieldType?: string;
  fieldValue?: string;
  fieldNumberValue?: number;
  fieldDateValue?: string;
  fieldSelectValue?: string;
  fieldPredefinedValue?: string;
  fieldBooleanValue?: boolean;
}

/** Returns only the typed property selected by the field's current definition. */
export function getEvidenceFieldValue(field: TypedEvidenceValue): string | number | boolean | undefined {
  switch (field.fieldType) {
    case 'number':
      return field.fieldNumberValue;
    case 'date':
      return field.fieldDateValue;
    case 'select':
      return field.fieldSelectValue;
    case 'predefined':
      return field.fieldPredefinedValue;
    case 'checkbox':
      return field.fieldBooleanValue;
    default:
      return field.fieldValue;
  }
}
